import PropTypes from "prop-types";
import {featureInterface} from "../../interfaces/featureInterface";

export const CART_ITEM_ADDED_BY = {
  user: "user",
  auto: "auto",
}

export const cartItemInterface = {
  id: PropTypes.string, // unique id used on frontend
  isEmpty: PropTypes.bool,
  isMinimumCharge: PropTypes.bool,  // is used for lowes, added when countertops sqft is lower than 23
  isMinimumChargeItems: PropTypes.bool, // is used for lowes, between 23 and 27 countertops sqft
  selectionGroup: PropTypes.string,
  partId: PropTypes.string.isRequired,
  currentQuote: PropTypes.number,
  cartFeature: PropTypes.shape(featureInterface),
  quantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), // empty input case
  displayFakeQuantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), // for slab (countertop group)
  sqftId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), // if feature was added from SQFT
  unit: PropTypes.string, // was added for SQFT,
  qtCatName: PropTypes.string, // was added for SQFT,
  relatedProductParent: PropTypes.shape(featureInterface), //
  addedBy: PropTypes.oneOf([CART_ITEM_ADDED_BY.auto, CART_ITEM_ADDED_BY.user]), // can be user or auto (if cart list were created by the default(see createCartList function in lookVisualizer.js))
  isRemoved: PropTypes.bool,
  keepOnLookUpdate: PropTypes.bool, // in case it was added from wizard List - we don't need to remove it on look update cart items logic
  shippingName: PropTypes.string,
  shippingTime: PropTypes.string,
  shippingCost: PropTypes.number,
  fromWizardId: PropTypes.number, // wizard item id
  fromWizardStep: PropTypes.number, // wizard step (index)
  fromWizardGroupId: PropTypes.string, // wizard group
  isAddedFromDisplayLogic: PropTypes.bool, // if cart item was added automatically
  fromVisualizerType: PropTypes.string,
  fromQtCategory: PropTypes.string, // category name (to proper switch)
  bundleParentId: PropTypes.string, // parent cart item id (hash)
  subGroupTitle: PropTypes.string, // comes from sqft like Doors/Drawers
  cartItemPrice: PropTypes.number, // is used for complex logic
};
